import React, { memo } from 'react';

const NotFoundScreen = memo(() => {
  return <div className="h-"></div>;
});

NotFoundScreen.displayName = 'NotFoundScreen';

export { NotFoundScreen };
